/**
 * agw模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const agw = {
  //分页
  pageAgw(params) {
    return $http.post(`${global.API_URL}/sme/agw/page`,params);
  },
  //查询当前用户下所有AGW
  queryAccountApplicationGateways(params) {
    return $http.post(`${global.API_URL}/sme/agw/queryAccountApplicationGateways`,params);
  },
  //根据name查询agw
  queryApplicationGatewayByName(params) {
    return $http.post(`${global.API_URL}/sme/agw/queryApplicationGatewayByName`,params);
  },
  //删除
  deleteAgw(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/agw/delete`,param);
  }
}

export default agw;



// WEBPACK FOOTER //
// ./src/api/agw.js